import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@components/common/tooltip/main';

import './styles/checkbox.scss';

let checkboxIdCounter = 0;

const renderLabel = ({ checkboxId, titleId, label, labelHtml, tooltipCopy }) => (
  <React.Fragment>
    <label
      className="checkbox-title"
      htmlFor={checkboxId}
      id={titleId}
    >
      {label ? label : labelHtml}
    </label>
    {tooltipCopy ? (
      <Tooltip
        tooltipId={`checkbox-question-${label ? label.replace(" ", "") : labelHtml.props.children.replace(" ", "")}`}
        tooltipContent={tooltipCopy}
      >
        <span
          className="bff-tool-tip icon"
          aria-label="require identification info"
          style={{ marginLeft: "10px" }}
        />
      </Tooltip>
    ) : (
      ""
    )}
  </React.Fragment>
);

const Checkbox = (props) => {
  const generatedIdRef = useRef(null);
  if (generatedIdRef.current === null) {
    generatedIdRef.current = `bf-checkbox-${++checkboxIdCounter}`;
  }
  const checkboxId = props.datakey || generatedIdRef.current;
  const titleId = `${checkboxId}-title`;
  const hasVisibleLabel = !!(props.label || props.labelHtml);
  const isMixed = props.partiallySelected === 'partially-selected';
  const labelProps = {
    checkboxId,
    titleId,
    label: props.label,
    labelHtml: props.labelHtml,
    tooltipCopy: props.tooltipCopy,
  };

  return (
    <div
      className={`checkbox-content-container no-print ${props.size} align-${props.labelAlign} ${props.className}`}
      onClick={(e) => {
        // Clicks on the label/input must not bubble (e.g. asset card wrapper opens modal on click).
        e.stopPropagation();
      }}
    >
      {props.labelAlign === "right" && hasVisibleLabel ? renderLabel(labelProps) : " "}
      <span className="input-container">
        <input
          aria-checked={isMixed ? 'mixed' : props.checked}
          aria-label={props.ariaLabel || (typeof props.label === 'string' ? props.label : undefined)}
          aria-labelledby={!props.ariaLabel && hasVisibleLabel ? titleId : undefined}
          checked={props.checked}
          className={`c-custom-checkbox ${props.partiallySelected}`}
          data-key={props.datakey}
          data-testid={`checkbox-input-${props.datakey}`}
          disabled={props.disabled}
          id={checkboxId}
          onChange={(e) => { e.stopPropagation(); }}
          onClick={(e) => {
            // The input is the click target (overlay has pointer-events:none).
            // Use onClick instead of onChange so the click event's shiftKey is
            // available to callers (e.g. shift+click range selection).

            e.stopPropagation();
            props.toggle(e);
          }}
          type="checkbox"
          value={props.checked ? "checked" : 0}
        />
        <label
          aria-hidden="true"
          className={`checkbox-overlay ${props.checked ? 'checked' : 'c-custom-checkbox-hover'}`}
          data-key={props.datakey}
          htmlFor={checkboxId}
        />
      </span>
      {props.labelAlign !== "right" && hasVisibleLabel ? renderLabel(labelProps) : " "}
    </div>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  datakey: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelAlign: PropTypes.string,
  labelHtml: PropTypes.shape({}),
  partiallySelected: PropTypes.string,
  size: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  // tooltipCopy: PropTypes.string,
};

Checkbox.defaultProps = {
  className: '',
  datakey: null,
  disabled: false,
  labelAlign: null,
  label: null,
  labelHtml: null,
  partiallySelected: '',
  size: 'sm',
  ariaLabel: null
  // tooltipCopy: null,
};

export default Checkbox;
